export default {
    actionButton: {
        fontWeight: 600,
        whiteSpace: 'nowrap',
        fontSize: 14,
        letterSpacing: '0.2px'
    }
};
